var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"container-fluid flex-grow-1 d-flex bg-lighter"},[_c('div',{staticClass:"row flex-grow-1 mt-5"},[_c('div',{staticClass:"col px-4"},[_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_vm._t("heading"),_vm._v(" "),_vm._t("content")],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b047676","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublicLayout.vue
// module id = 994
// module chunks = 30